export const SITE = {
  DOMAIN: import.meta.env.VITE_PUBLIC_APP_DOMAIN || '',
  TITLE: '生活クラブ配送状況確認',
  FAVICON_SRC: '/icon.svg',
};
